<template>
    <div class="chat-body">
        <div class="chat-content">
            <div
                :class="
                    groupDirection === 'out'
                        ? `bg-${resolvePlatformColor(formattedActiveChatData.channel.platform)}-light`
                        : ''
                "
                class="chat-entry chat-entry-event text-secondary"
            >
                <p v-if="this.hasActor()">
                    {{
                        $t(getEvent().text, {
                            actor: getEvent().actor,
                            target: getEvent().target,
                            date: formatDate(entry.time, {
                                month: "numeric",
                                day: "numeric",
                                year: "numeric",
                            }),
                            time: formatDate(entry.time, {
                                hour: "2-digit",
                                minute: "2-digit",
                            }),
                        })
                    }}
                </p>
                <p v-if="entry.name === 'Conversation::start'">
                    {{
                        formatDate(entry.time, {
                            month: "numeric",
                            day: "numeric",
                            year: "numeric",
                        })
                    }}
                </p>

                <small v-if="entry.type !== 'event'" class="chat-time">
                    {{
                        formatDate(entry.time, {
                            hour: "2-digit",
                            minute: "2-digit",
                        })
                    }}
                </small>
            </div>
        </div>
    </div>
</template>

<script>
import { resolveMessageStatusIcon, resolveMessageStatusClass } from "@/utils/chats";
import { formatDate } from "@/utils/luxon";
import { resolvePlatformColor } from "@/utils/channels";

export default {
    props: {
        entry: {
            type: Object,
            required: true,
        },
        groupDirection: {
            type: String,
            required: false,
        },
        formattedActiveChatData: {
            type: Object,
            required: true,
        },
    },
    methods: {
        hasActor() {
            return !!this.entry.actor;
        },
        getActor() {
            return this.entry.actor;
        },
        getTarget() {
            return this.entry.target;
        },
        getPayload() {
            return this.entry.payload;
        },
        getEvent() {
            const actor = this.getActor();
            //const target  = this.getTarget();
            const payload = this.getPayload();

            switch (this.entry.name) {
                case "Conversation::assign":
                    return {
                        actor: actor.actorFullName,
                        text: "has-assigned-conversation-to",
                        target: payload.extra ? payload.extra.assignedName : "",
                    };
                case "Conversation::unassign":
                    return {
                        actor: actor.actorFullName,
                        text: "has-unassigned-conversation",
                    };
                case "Conversation::archive":
                    return {
                        actor: actor.actorFullName,
                        text: "has-archived-conversation-on",
                    };
                case "Conversation::unarchive":
                    return {
                        actor: actor.actorFullName,
                        text: "has-unarchived-conversation-on",
                    };
                case "Conversation::routed":
                    return {
                        actor: actor.actorFullName,
                        text: "conversation-was-auto-assigned",
                    };
            }

            return this.getActor().actorFullName;
        },
    },
    setup() {
        return {
            formatDate,
            resolvePlatformColor,
            resolveMessageStatusIcon,
            resolveMessageStatusClass,
        };
    },
};
</script>
